import React from "react"
import { Badge, rem } from "@mantine/core"
import { Button } from "@/components"
import { CopilotSparkleIcon } from "./CopilotSparkleIcon"
import { useCopilotContext } from "@/components/CopilotAnalyze/Copilot.context"
import { useToggleCopilotChat } from "@/components/CopilotAnalyze/hooks/useToggleCopilotChat"
import { useStyles } from "./styles"

interface Props {
    popdownIsOpen: boolean
}

export const CopilotAnalyzeToggle = (props: Props) => {
    const { classes, cx } = useStyles()
    const { unreadSessions } = useCopilotContext()
    const { isOpen, toggleChat } = useToggleCopilotChat()

    const handleClick = () => {
        toggleChat()

        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur()
        }
    }

    return (
        <div style={{ position: "relative" }}>
            <Button
                variant="outline"
                className={cx(classes.button, {
                    [classes.active]: isOpen,
                    [classes.popdownIsOpen]: props.popdownIsOpen,
                    [classes.isOpened]: isOpen && props.popdownIsOpen,
                })}
                onClick={handleClick}
                data-plum-id={`copilot-2-navbar-${isOpen ? "close" : "open"}`}
                aria-label="Toggle Copilot Analyze"
            >
                <CopilotSparkleIcon
                    popdownIsOpen={props.popdownIsOpen}
                    isOpen={isOpen}
                    shouldAnimate={unreadSessions.length > 0}
                />
            </Button>
            {unreadSessions.length > 0 && (
                <Badge
                    color="red.5"
                    variant="filled"
                    style={{
                        height: rem(22),
                        width: rem(22),
                        padding: 0,
                        borderRadius: "100%",
                        position: "absolute",
                        left: "1.25rem",
                    }}
                >
                    {unreadSessions.length}
                </Badge>
            )}
        </div>
    )
}
